import { Component, Input, Output, EventEmitter } from '@angular/core';
import {NgClass} from "@angular/common";

type BtnSize = 'xs' | 'md';

@Component({
    selector: 'app-orange-button',
    templateUrl: './orange-button.component.html',
    styleUrls: ['./orange-button.component.scss'],
    imports: [
        NgClass
    ],
    standalone: true
})
export class OrangeButtonComponent {
    @Input() text: string = 'Get Started';
    @Input() size: BtnSize = 'xs';
    @Output() action = new EventEmitter<void>();
}
